import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { ScrollArea } from '../../ui/scroll-area';
import MessagesEmpty from './MessagesEmpty';
import IndividualMessage from './IndividualMessage';
import { LoadingSpinner } from '../../ui/loading-spinner';
import UserChatInput from './UserChatInput';
import { getDocumentText } from '../../lib/office';
import { useChatContext } from './ChatContext';
import { useUserId } from '../../lib/useUserId';
import OAuthConnectWidget from '../oauth/OAuthConnectWidget';
const Chat = () => {
    const { messages, sendMessage, sendButtonDisabled } = useChatContext();
    const { userId } = useUserId();
    const [inputText, setInputText] = React.useState('');
    const scrollAreaRef = React.useRef(null);
    // Auto-scroll to bottom when messages change
    useEffect(() => {
        if (scrollAreaRef.current) {
            const scrollContainer = scrollAreaRef.current.querySelector('[data-radix-scroll-area-viewport]');
            if (scrollContainer) {
                scrollContainer.scrollTop = scrollContainer.scrollHeight;
            }
        }
    }, []);
    const onMessageSend = async (e) => {
        e.preventDefault();
        setInputText('');
        try {
            if (!userId) {
                console.error('User ID not available');
                return;
            }
            const documentText = await getDocumentText();
            await sendMessage({
                userInput: inputText,
                userId,
                inMemoryMessages: [
                    {
                        role: 'user',
                        message: documentText,
                    },
                    ...messages.map((m) => ({
                        role: m.role,
                        message: m.value,
                    })),
                ],
            });
        }
        catch (error) {
            console.error(error);
        }
    };
    return (_jsxs("div", { className: "relative w-full h-[calc(100%-90px)] flex flex-col justify-between bg-background pt-4", children: [_jsxs(ScrollArea, { ref: scrollAreaRef, children: [_jsx("div", { className: "px-4 mb-4", children: _jsx(OAuthConnectWidget, {}) }), messages.length <= 0 && _jsx(MessagesEmpty, {}), messages.length > 0 && (_jsxs("div", { className: 'flex flex-col gap-2', children: [_jsx(IndividualMessage, { message: {
                                    role: 'assistant',
                                    value: 'How can I help?',
                                    id: 'greeting',
                                } }), messages.map((message) => (_jsx(IndividualMessage, { message: message }, message.id)))] })), sendButtonDisabled && (_jsx("div", { className: 'flex justify-center', children: _jsx(LoadingSpinner, {}) }))] }), _jsx("div", { className: 'w-full', children: _jsx(UserChatInput, { onMessageSend: onMessageSend, value: inputText, onChange: setInputText, sendButtonDisabled: sendButtonDisabled || !inputText.trim() }) })] }));
};
export default Chat;
